<template>
  <div class="schedule-calendar-container" style="margin:20px 0">
    <!-- 연,월 -->
    <div class="flex flex-center justify-center" style="margin-bottom:8px">
      <div class="flex">
        <i class="material-icons icon-arrow unselect" @click="clickPrev">keyboard_arrow_left</i>
        <div>{{ `${this.currentDate.year()}년 ${this.currentDate.month()+1}월` }}</div>
        <i class="material-icons icon-arrow unselect" @click="clickNext">keyboard_arrow_right</i>
      </div>
    </div>

    <!-- 요일 -->
    <div class="flex wrap">
    <div class="lp-day"
      v-for="(day,idx) in days" :key="'day-'+idx">{{ day }}</div>
    </div>
    <!-- 일 -->
    <div class="flex wrap lp-dates">
      <div class="lp-date unselect"
           v-for="(date,idx) in dates" :key="'date-'+idx"
           @click="clickDate(date,idx)">
        <div v-if="date.operatingTime && date.operatingTime.is_closed" class="flex justify-center" style="height:100%;align-items: center">
          <div style="color:red;text-align:center">휴무</div>
        </div>
        <div v-else style="height:100%">
          <!-- 일자 표시 -->
          <div :style="dayStyle(date)">{{ date.day > 0 ? date.day : '' }}</div>
          <!-- 일에 해당하는 시간 스케쥴 -->
          <div v-if="date.times" class="relative">
            <div v-for="(time, timeIdx) in date.times.slice(0,3)"
                 :key="date.day+'-time-'+timeIdx">
              <!-- 브레이크 타임 -->
              <div  v-if="time.break_time"
                    class="lp-break-time">{{ `${timeToStr(time.start_time)} ~ ${timeToStr(time.end_time)}` }}</div>
              <!-- 일반 시간 스케쥴 -->
              <div v-else class="flex space-between lp-time" :class="{'lp-time-before': time.isBefore}" @click.stop.prevent="clickTime(date, timeIdx)">
                <div>{{ `${timeToStr(time.start_time)} ~ ${timeToStr(time.end_time)}` }}</div>
                <div>{{ time.ordered_count }}</div>
              </div>
            </div>
            <div class="lp-time-all" v-if="date.times.length>3" @click.stop.prevent="clickAll(date)">전체 보기({{ date.times.length }})</div>
            <!-- 스케쥴 전체 -->
            <div v-show="vTimeAll && selectedDate.start_date === date.start_date" class="box-schedule" @click.stop.prevent="">
              <div class="flex space-between flex-center" style="margin-bottom:4px">
                <div style="width:24px"></div>
                <div style="color:#989898;font-weight:600">{{ date.start_date }}</div>
                <i class="material-icons" @click="vTimeAll=false">close</i>
              </div>
              <div v-for="(time, timeIdx) in date.times"
                   :key="date.day+'-time-'+timeIdx">
                <!-- 브레이크 타임 -->
                <div  v-if="time.break_time"
                      class="lp-break-time">{{ `브레이크 타임 ${timeToStr(time.start_time)} ~ ${timeToStr(time.end_time)}` }}</div>
                <!-- 일반 시간 스케쥴 -->
                <div v-else class="flex space-between lp-time" :class="{'lp-time-before': time.isBefore}" @click="clickTime(date, timeIdx)">
                  <div>{{ `${timeToStr(time.start_time)} ~ ${timeToStr(time.end_time)}` }}</div>
                  <div>{{ time.ordered_count }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="date.all_time" class="item-day-all" style="height:70%" @click="clickAllTime(date)">하루 종일</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: "ResvCalendar",
    data() {
      return {
        vTimeAll: false,
        days: ['일','월','화','수','목','금','토'],
        dates: [],
        newDates: [],
        currentDate: '',
        selectedDate: undefined,
        selectedDateIndex: -1,
      }
    },
    created() {
      this.currentDate = moment();
      this.setDates(true);
    },
    methods: {
      // 시간 스케쥴 클릭
      clickTime(date, timeIdx) {
        if(date.times[timeIdx].isBefore) return;

        this.$emit('clickTime', {
          date: date.start_date,
          start_time: date.times[timeIdx].start_time,
          end_time: date.times[timeIdx].end_time
        });
      },
      // 하루 종일 클릭
      clickAllTime(date) {
        this.$emit('clickTime', {
          date: date.start_date,
          all_time: true
        });
      },
      // 전체 보기 클릭
      clickAll(date) {
        this.selectedDate = date;
        this.vTimeAll = true;
      },
      timeToObject(time) {
        let result = {
          hour: 0,
          min: 0
        };
        if(time && time.indexOf(':')>-1) {
          let times = time.split(':');
          result.hour = parseInt(times[0]);
          result.min = parseInt(times[1]);
        }
        return result;
      },
      refreshDates() {
        this.getMonthly();
      },

      clickDate(date,idx) {
        if(
          (date.operatingTime.is_closed || date.day === 0 || (date.times && date.times.length > 0))
        ) return;

        this.selectedDate = this.cloneItem(date);
        this.selectedDateIndex = idx;
      },
      getWeeksDays(dates) {
        let selDate = moment(dates);
        let date = selDate.date();
        let day = selDate.day();
        let end_month = selDate.endOf('month').date();
        return {
          isLast: (date + 7 > end_month),
          week: Math.ceil(date/7),
          day: day,
          dayStr: ['일','월','화','수','목','금','토'][day]
        }
      },

      clickPrev() {
        this.currentDate.subtract(1, 'months');
        this.setDates(false);
      },
      clickNext() {
        this.currentDate.add(1, 'months');
        this.setDates(false);
      },
      timeToInt(time) {
        time = time.split(':');
        return parseInt(`${time[0]}${time[1]}`);
      },
      timeToStr(time) {
        if(time) {
          time = time.split(':');
          return `${time[0]}:${time[1]}`;
        } else {
          return time;
        }
      },

      async setDates(isFirst) {
        let year = this.currentDate.year();
        let month = this.currentDate.month()+1;
        let now = moment().format('YYYY-MM-DD');

        let res = await this.$axios.get(this.getUrl(`product/schedule/monthly/${year}-${month}`));
        this.dates = [];
        res.data.dates.forEach(date => {
          date.now = now === date.start_date;
          if(date.times){
            date.times.forEach(time => {
              time.isBefore = moment().isAfter(moment(date.start_date + ' ' + time.start_time));
            });
          }
          this.dates.push(date);
        });


        if(isFirst) {
          for(let i=0; i<this.dates.length; i++) {
            let date = this.dates[i];
            if(date.day >= this.currentDate.day() && date.times && date.times.length > 0) {
              let timeIdx = -1;
              for(let j=0; j<date.times.length; j++) {
                let time = date.times[j];
                if(!time.isBefore) {
                  timeIdx = j;
                  break;
                }
              }
              if(timeIdx > -1) {
                this.clickTime(date, timeIdx);
                break;
              }
            }
          }
        }
      },
      dayStyle(day) {
        let deco = {
          padding: '4px',
          textAlign: 'center'
        }
        if(day.now) {
          deco.color = 'red';
        }
        return deco;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .lp-day
    width 14.2857%
    text-align center
    padding-bottom 4px

  .lp-dates
    border-right 1px solid #ddd
    border-bottom 1px solid #ddd

  .lp-date
    width 14.2857%
    height 128px
    border-top 1px solid #ddd
    border-left 1px solid #ddd

  .lp-date:hover
    background #f5f5f5

  .icon-arrow
    padding 0px 8px

  .lp-title
    color #707070
    font-size 15px
    margin 24px 0 8px 0

  .lp-title:first-child
    margin-top 0

  input[type="number"]
    height 36px
    width 56px

  .lp-time
  .lp-break-time
    font-size 11px
    padding 2px 4px
    margin-bottom 4px
    color #656565

  .lp-time
    background rgba(255,88,49,0.15)
  .lp-time:hover
    background rgba(255,88,49,0.4)

  .lp-time-before
    background-color white
  .lp-time-before:hover
    background-color white

  .lp-break-time
    text-align center
    background #eeeeee

  .lp-time-all
    color #707070
    font-size 12px
    padding 0 4px
    margin-top 8px
    font-weight 600

  .box-schedule
    position absolute
    left 93px
    top 0
    z-index 100
    background white
    padding 8px 16px
    width 200px
    box-shadow 0 2px 6px 0 rgba(0,0,0,0.3)

  .item-day-all
    display flex
    justify-content center
    align-items center
    height 100%
  .item-day-all div
    text-align center
</style>
